module.exports = __webpack_public_path__ + "static/waltz_roll_mini_2-81642dd5303496e997781c5a316f1fa8.jpg";